import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  sectionProgress: [],
  sectionProgressRef: null,
  sectionProgressLoaded: false
}

const getters = {
  sectionProgress (state) {
    return state.sectionProgress
  },
  sectionProgressRef (state) {
    return state.sectionProgressRef
  },
  sectionProgressLoaded (state) {
    return state.sectionProgressLoaded
  },
  sectionProgressByKey (state) {
    return (sectionProgressKey) => {
      return state.sectionProgress.find(p => {
        return p.key === sectionProgressKey
      })
    }
  },
  sectionProgressByContentProgressByUrl (state) {
    return (contentProgressKey, sectionProgressUrl) => {
      return state.sectionProgress.find(p => {
        return (p.contentProgressKey === contentProgressKey) && (p.url === sectionProgressUrl)
      })
    }
  },
  sectionProgressByContentProgressBySection (state) {
    return (contentProgressKey, sectionKey) => {
      return state.sectionProgress.find(p => {
        return (p.contentProgressKey === contentProgressKey) && (p.sectionKey === sectionKey)
      })
    }
  }
}

const mutations = {
  setSectionProgress (state, payload) {
    state.sectionProgress = payload
  },
  setSectionProgressRef (state, payload) {
    state.sectionProgressRef = payload
  },
  setSectionProgressLoaded (state, payload) {
    state.sectionProgressLoaded = payload
  }
}

const actions = {
  loadSectionProgress: (store, payload) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('sectionProgress').child(payload)
    ref.on('value', snapshot => {
      const sectionProgress = []
      snapshot.forEach(p => {
        sectionProgress.push({key: p.key, ...p.val()})
      })
      store.commit('setSectionProgress', sectionProgress)
      store.commit('setSectionProgressRef', ref)
      store.commit('setSectionProgressLoaded', true)
      resolve()
    })
  }),
  createSectionProgress: (store, payload) => new Promise((resolve, reject) => {
    const newSectionProgress = {...payload}
    store.getters.sectionProgressRef.push(newSectionProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateSectionProgress: (store, payload) => new Promise((resolve, reject) => {
    const newSectionProgress = {...payload}
    store.getters.sectionProgressRef.child(newSectionProgress.key).set(newSectionProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetSectionProgress: (store) => new Promise((resolve, reject) => {
    if (store.getters.sectionProgressRef) store.getters.sectionProgressRef.off()
    store.commit('setSectionProgress', [])
    store.commit('setSectionProgressRef', null)
    store.commit('setSectionProgressLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/student/sectionProgress.js